// extracted by mini-css-extract-plugin
export var layoutContainer = "_5e-0";
export var layoutContainerNoRounding = "_5e-6";
export var layoutContainerOpen = "_5e-5";
export var layoutContainerResizing = "_5e-1";
export var mainContent = "_5e-2";
export var resizeDivider = "_5e-3";
export var slidePanel = "_5e-4";